// extracted by mini-css-extract-plugin
export var entityChip = "_sm-0";
export var entityChipMissing = "_sm-1";